import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductPrice } from '../models/product-price';
import { ProductPriceRequest } from './models/product-price-request';
import { SupplierSpecialOffer } from '../models/supplier-special-offer';

export class ProductDetailPricesApi {
    constructor(protected baseUrl: string) {}

    public getPrices(id: number): Promise<ApiResult<ProductPrice>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/prices`),
            response => response.data
        );
    }

    public getSupplierSpecialOffers(id: number): Promise<ApiResult<SupplierSpecialOffer[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/prices/available-special-offers`),
            response => response.data
        );
    }

    public patchPrices(productId: number, productRequest: ProductPriceRequest): Promise<ApiResult<ProductPrice>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/products/${productId}/prices`, productRequest),
            response => response.data
        );
    }
}
